import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'

type State = {
  isInfographic: boolean
  layout: 'portrait' | 'landscape'
  size: 'social-media' | 'presentation'
  title: boolean
  legend: boolean
  dimension: {
    width: number
    height: number
  }
}
const dimensions = {
  'social-media': {
    landscape: {
      width: 800,
      height: 600
    },
    portrait: {
      width: 600,
      height: 800
    }
  },
  presentation: {
    landscape: {
      width: 1024,
      height: 768
    },
    portrait: {
      width: 768,
      height: 1024
    }
  }
}

const initialState: State = {
  isInfographic: false,
  layout: 'landscape',
  size: 'social-media',
  title: true,
  legend: true,
  dimension: {
    width: 300,
    height: 600
  }
}

export const infographicSlice = createSlice({
  name: 'infographic',
  initialState,
  reducers: {
    setIsInfographic: (state, action) => {
      state.isInfographic = action.payload
    },
    setLayout: (state, action) => {
      state.layout = action.payload
    },
    setTitle: (state, action) => {
      state.title = action.payload
    },
    setLegendInfographic: (state, action) => {
      state.legend = action.payload
    },
    setSize: (state, action) => {
      state.size = action.payload
    }
  }
})

const selectDimension = (state) =>
  dimensions[state.infographic.size][state.infographic.layout]

const selectIsInfographic = (state) => state.infographic.isInfographic
const selectLayout = (state) => state.infographic.layout
const selectTitle = (state) => state.infographic.title
const selectLegend = (state) => state.infographic.legend

export const useDimension = () => useSelector(selectDimension)
export const useIsInfographic = () => useSelector(selectIsInfographic)
export const useLayout = () => useSelector(selectLayout)
export const useInfographicTitle = () => useSelector(selectTitle)
export const useInfographicLegend = () => useSelector(selectLegend)

export const {
  setSize,
  setTitle,
  setIsInfographic,
  setLayout,
  setLegendInfographic
} = infographicSlice.actions

export default infographicSlice.reducer
